<template>
  <a-card :bordered='false' :bodyStyle="{paddingTop:'10px'}" :headStyle="{ borderBottom: '0px', fontSize: '18px' }">
    <div style='margin-top: 20px;margin-bottom: 20px'>
      <span class="pdr15">用户手机号:</span>
      <a-input v-model="queryParams.memberPhone" style='width: 350px;' placeholder='请输入用户手机号' :maxLength="20"
               allowClear></a-input>
      <a-button type="primary" @click="onSearch" style="margin-left: 20px">查询</a-button>
    </div>
    <custom-page-table
      ref='table'
      :enableSearch="false"
      :requestPromise="loadPromise"
      :columns='getColumns()'
      :query-params='queryParams'
    >
      <span slot='contactSlot'
            slot-scope='rowItem'>{{ rowItem.record.memberNickname }}/{{ rowItem.record.memberPhone }}</span>
    </custom-page-table>
  </a-card>
</template>

<script>
import GuWeiMixins from '@/views/service/serviceProvider/guWei/mixins/GuWeiMixins'

export default {
  name: 'GuWeiInvitationRecord',
  mixins: [GuWeiMixins],
  components: {},
  data() {
    return {
      queryParams: {
        memberPhone: '',
        merchantId: this.$store.getters.userInfo.merchantId
      },
      loadPromise: params => this.getListPromise(params)
    }
  },
  mounted() {
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getApiService().post('api/gw/admin/invite/listPage', params)
    },
    onSearch() {
      this.$refs.table.refresh(true)
    },
    getColumns() {
      return [
        {
          title: '用户',
          dataIndex: 'memberNickname',
          scopedSlots: { customRender: 'contactSlot' }
        },
        {
          title: '好友昵称',
          dataIndex: 'friendNickname'
        },
        {
          title: '缴费人数',
          dataIndex: 'payCount'
        },
        {
          title: '邀请时间',
          dataIndex: 'inviteTime'
        },
        {
          title: '状态',
          dataIndex: 'statusStr'
        }
      ]
    }
  }

}
</script>
<style scoped lang='less'>
.pdr15 {
  padding-right: 15px;
}
</style>